module.exports = __webpack_public_path__ + "img/kakao-talk.736316ee.svg";